import { Outlet, useMatch } from 'react-router-dom';
import AssignmentApproval from 'components/AssignmentApproval';
import SubMenu, { SubMenuTitle } from 'components/SubMenu';
import Routes from 'constants/Routes';
import useHasAccessToHRSpeedingReport from 'hooks/useHasAccessToHRSpeedingReport';

const AfterControlPage = () => {
  const canSeeSpeeding = useHasAccessToHRSpeedingReport();

  // AssignmentApproval is the default content on /efterkontroll. Hide it on the
  // speeding sub-route so the Outlet's HRSpeedingPage renders alone.
  const isSpeedingRoute = useMatch(Routes.afterControl.speeding);

  const items = [
    {
      label: <SubMenuTitle>Uppdragsgodkännande</SubMenuTitle>,
      path: Routes.afterControl.index,
    },
    ...(canSeeSpeeding
      ? [
          {
            label: <SubMenuTitle>Hastighet & GPS</SubMenuTitle>,
            path: Routes.afterControl.speeding,
          },
        ]
      : []),
  ];

  return (
    <>
      <SubMenu items={items} />
      {!isSpeedingRoute && <AssignmentApproval />}
      <Outlet />
    </>
  );
};

export default AfterControlPage;
